export default "__VITE_PUBLIC_ASSET__7c798a66__"